import { Component, ReactFragment, Fragment } from "react";
import * as React from "react";
import { Icon, TextField } from "office-ui-fabric-react";
import { MegaMenuOption, MegaMenuOptions } from "../../MegaMenuItemSelector";
import School, { licenseLevelIsAtLeast } from "../../../models/School";
import * as _ from "lodash";

export interface MegaMenuCardProps {
    school: School;
    megaMenuOptions: MegaMenuOptions;
    onMegaMenuOptionsChanged(updatedMegaMenuOptions: MegaMenuOptions): void;
}

export interface MegaMenuCardState {
}

export default class MegaMenuCard extends Component<MegaMenuCardProps, MegaMenuCardState>
{
    constructor(props: Readonly<MegaMenuCardProps>) {
        super(props);

        this.state = {
        };
    }


    componentDidUpdate(prevProps: Readonly<MegaMenuCardProps>, prevState: Readonly<MegaMenuCardState>, snapshot?: any): void {
    }

    public componentDidMount() {
    }

    private buildSilverColumns(): ReactFragment {
        return (
            <Fragment>
                <TextField
                    className="flex-item--flex-1 m-right-1rem"
                    disabled={true}
                    label="Third Column"
                    value={"My Subjects"}
                    description={"Provided with your license"}
                    required={false}
                />

                <TextField
                    className="flex-item--flex-1 m-right-1rem"
                    disabled={true}
                    label="Fourth Column"
                    value={"Classes"}
                    description={"Provided with your license"}
                    required={false}
                />
            </Fragment>
        );
    }

    private buildFoundationColumns(): ReactFragment {
        return (
            <Fragment>
                <TextField
                    className="flex-item--flex-1 m-right-1rem"
                    disabled={false}
                    label="Third Column"
                    value={this.props.megaMenuOptions.three?.listName}
                    onChange={(e) => this.setListName(e, "three")}
                    required={false}
                />
                <TextField
                    className="flex-item--flex-1 m-right-1rem"
                    disabled={false}
                    label="Fourth Column"
                    value={this.props.megaMenuOptions.four?.listName}
                    onChange={(e) => this.setListName(e, "four")}
                    required={false}
                />
            </Fragment>
        );
    }


    private setListName = (e: any, optionKey: string) => {

        const updatedOptions: MegaMenuOptions = _.cloneDeep(this.props.megaMenuOptions);

        const option: MegaMenuOption | null = updatedOptions[optionKey];
        if (option) {
            option.listName = e.target.value;
        }
        else {
            updatedOptions[optionKey] = { listName: e.target.value, sitePathForList: "" };
        }

        this.props.onMegaMenuOptionsChanged(updatedOptions);
    }

    public render() {
        return (
            <div className="card">

                <div className={"card__header"}>
                    <Icon iconName="Menu" className={"p-left-1rem"} />
                    <div className={"card__title"}>
                        <span>Your Mega Menu</span>
                    </div>
                </div>


                <div className={"card__content"}>
                    <TextField
                        className="flex-item--flex-1 m-right-1rem"
                        disabled={false}
                        label="First Column"
                        value={this.props.megaMenuOptions.one?.listName}
                        onChange={(e) => this.setListName(e, "one")}
                        required={false}
                    />

                    <TextField
                        className="flex-item--flex-1 m-right-1rem"
                        disabled={false}
                        label="Second Column"
                        value={this.props.megaMenuOptions.two?.listName}
                        onChange={(e) => this.setListName(e, "two")}
                        required={false}
                    />

                    {licenseLevelIsAtLeast(this.props.school.license, "silver") ? this.buildSilverColumns() : this.buildFoundationColumns()}
                </div>

            </div>
        );
    }
}